<template>
  <div class="g-box table home-container" :style="{height:height+'px'}">
    <div style="font-size:40px;">404~！</div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  data() {
    return {
      height: 400
    };
  },

  computed: {},

  created() {
    this.height = document.body.clientHeight - 125;
  },

  methods: {},

  components: {}
};
</script>

<style lang="less" rel="stylesheet/less" scoped="true">
@import url("../../common/less/variable.less");
</style>
